import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '../components/layout/app-shell';
import { AddressesPage } from '../pages/addresses-page';
import { AuditLogPage } from '../pages/audit-log-page';
import { AdminsPage } from '../pages/admins-page';
import { AppointmentReasonsPage } from '../pages/appointment-reasons-page';
import { AppointmentsPage } from '../pages/appointments-page';
import { ArticleCategoriesPage } from '../pages/article-categories-page';
import { ArticlesPage } from '../pages/articles-page';
import { BusinessTypesPage } from '../pages/business-types-page';
import { OfferCategoriesPage } from '../pages/offer-categories-page';
import { DirectoryCategoriesPage } from '../pages/directory-categories-page';
import { CompaniesPage } from '../pages/companies-page';
import { CountriesPage } from '../pages/countries-page';
import { DashboardPage } from '../pages/dashboard-page';
import { FormulasPage } from '../pages/formulas-page';
import { HelpPage } from '../pages/help-page';
import { MobileConfigPage } from '../pages/mobile-config-page';
import { LoginPage } from '../pages/login-page';
import { NotificationsPage } from '../pages/notifications-page';
import { OffersPage } from '../pages/offers-page';
import { PerformancePage } from '../pages/performance-page';
import { PregnancyPage } from '../pages/pregnancy-page';
import { UsersPage } from '../pages/users-page';
import { RequireAuth, RequireSuperAdmin } from './protected-route';

export function AppRouter(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="companies" element={<CompaniesPage />} />
        <Route path="offers" element={<OffersPage />} />
        <Route path="articles" element={<ArticlesPage />} />
        <Route path="pregnancy" element={<PregnancyPage />} />
        <Route path="addresses" element={<AddressesPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="appointments" element={<AppointmentsPage />} />
        <Route
          path="admins"
          element={
            <RequireSuperAdmin>
              <AdminsPage />
            </RequireSuperAdmin>
          }
        />
        <Route path="performance" element={<PerformancePage />} />
        <Route path="formulas" element={<FormulasPage />} />
        <Route path="countries" element={<CountriesPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="mobile-config" element={<MobileConfigPage />} />
        <Route path="article-categories" element={<ArticleCategoriesPage />} />
        <Route path="appointment-reasons" element={<AppointmentReasonsPage />} />
        <Route path="business-types" element={<BusinessTypesPage />} />
        <Route path="offer-categories" element={<OfferCategoriesPage />} />
        <Route path="directory-categories" element={<DirectoryCategoriesPage />} />
        <Route path="audit-log" element={<AuditLogPage />} />
        <Route path="help" element={<HelpPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
